/**
 * Copyright © 2026 Adnuntius AS.
 */
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {ButtonsModule} from 'ngx-bootstrap/buttons';

import {AppSharedModule} from '../../common/app-shared.module';
import {AdminResourcePagesModule} from '../../common/controller/admin-resource-pages.module';
import {AdnSelectComponent} from '../../common/directives/adn-select/adn-select.component';
import {AdminListModule} from '../../common/directives/admin-list.module';
import {CodemirrorFieldComponent} from '../../common/directives/codemirror-field.component';
import {FormControlsModule} from '../../common/directives/form-controls/form-controls.module';
import {AdminRichTextFieldComponent} from '../../common/directives/notes/admin-rich-text-field.component';
import {NotesComponent} from '../../common/directives/notes/notes.component';
import {ObjectNotesButtonComponent} from '../../common/directives/notes/object-notes-button.component';
import {LayoutComponentSummaryComponent} from '../../common/layout-component-summary-component';
import {LineItemLabelsModule} from '../../line-item/line-item-labels.module';
import {TargetingModule} from '../../targeting/targeting.module';
import {LayoutContextRoutePageComponent} from './layout-context-route-page.component';
import {LayoutCopyModalComponent} from './layout-copy-modal.component';
import {LayoutEditPageComponent} from './layout-edit-page.component';
import {LayoutExampleCopyModalComponent} from './layout-example-copy-modal.component';
import {LayoutListPageComponent} from './layout-list-page.component';
import {LayoutRoutePageComponent} from './layout-route-page.component';

const LAYOUT_COMPONENTS = [
  LayoutContextRoutePageComponent,
  LayoutCopyModalComponent,
  LayoutEditPageComponent,
  LayoutExampleCopyModalComponent,
  LayoutListPageComponent,
  LayoutRoutePageComponent
];

@NgModule({
  imports: [
    AppSharedModule,
    FormsModule,
    TranslateModule,
    UIRouterModule,
    ButtonsModule,
    AdminListModule,
    AdminResourcePagesModule,
    AdnSelectComponent,
    CodemirrorFieldComponent,
    FormControlsModule,
    LayoutComponentSummaryComponent,
    LineItemLabelsModule,
    AdminRichTextFieldComponent,
    NotesComponent,
    ObjectNotesButtonComponent,
    TargetingModule
  ],
  declarations: LAYOUT_COMPONENTS,
  exports: LAYOUT_COMPONENTS
})
export class LayoutModule {
}
